// BannerComponents.js
import styled from "styled-components";
import { NavLink as Link } from 'react-router-dom';

export const BannerContainer = styled.div`
  background-color: var(--secondary-background-color);
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 2rem;

  /* center container and limit max width */
  width: 100%;
  margin: 0 auto;
  padding: 2rem 2%;

  @media (max-width: 1200px) {
    flex-direction: column;
    align-items: center;
    padding: 2rem 5%;
  }

  @media screen and (min-width: 2559px) {
    padding: 0rem 20rem;
  }
`;

export const InfoContainer = styled.div`
  flex: 1;
  margin-top: 7rem;
  text-align: center;

  @media screen and (max-width: 1024px) {
    margin-top: 0rem;
  }
`;

export const TextContainer = styled.div`
   h1 {
    font-weight: bold;
    font-size: var(--headingSize);
    margin-bottom: 1rem;
    color: var(--textColor);

    @media (max-width: 1024px) {
      font-size: var(--smallerHeaderSize);
    }
  }

  h5 {
    font-size: var(--subHeadingSize);
    color: var(--textColor);

    @media (max-width: 1024px) {
      font-size: var(--smallerSubHeadingSize);
    }
`;

export const ButtonContainer = styled.div`
  padding-top: 4rem;
`;

export const Image = styled.img`
  flex: 1;
  max-width: 800px;
  width: 100%;
  height: auto;
  object-fit: contain;
  
  mask-image: radial-gradient(circle, rgba(0, 0, 0, 1) 80%, rgba(0, 0, 0, 0) 100%);
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: cover;
`;

export const DemoButtonLink = styled(Link)`
  border-radius: 8px;
  background-color: var(--main-color);
  font-size: 15px; 
  padding: 15px 15px;
  color: white;
  border: none;
  outline: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;

  &:hover {
    background: var(--hover-color);
    color: white;
  }
`;
